import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  SignUpCompanyData,
  SignUpInformationsData,
} from '../../interfaces/sign-up-store.interface';
import { IconsModule } from '../../../../../shared/design-system/icons/icons.module';

@Component({
  selector: 'app-recapitulatif-read',
  standalone: true,
  imports: [IconsModule],
  templateUrl: './recapitulatif-read.component.html',
  styleUrl: './recapitulatif-read.component.scss',
})
export class RecapitulatifReadComponent {
  @Input() mesInformations!: SignUpInformationsData;
  @Input() monEntreprise!: SignUpCompanyData;

  @Output() updateStep = new EventEmitter<number>();

  onUpdateStep(index: number) {
    this.updateStep.emit(index);
  }
}
